/**
 * Simple PDP Accordion - Custom FAQ functionality
 * Uses theme wt-collapse classes but custom JS logic.
 */

(() => {
  if (window.YellowdayPDPAccordion) {
    window.YellowdayPDPAccordion.initAll();
    return;
  }

  class PDPAccordion {
    constructor(container) {
      this.container = container;
      this.items = this.container.querySelectorAll('.wt-collapse');
      this.init();
    }

    init() {
      for (const item of this.items) {
        const trigger = item.querySelector('.wt-collapse__trigger');
        if (!trigger) continue;

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggle(item, trigger);
        });
      }
    }

    toggle(item, trigger) {
      const isOpen = item.classList.contains('is-open');
      const content = item.querySelector('.wt-collapse__target');

      if (isOpen) {
        this.close(item, trigger, content);
        return;
      }

      for (const other of this.items) {
        if (other === item) continue;

        const otherTrigger = other.querySelector('.wt-collapse__trigger');
        const otherContent = other.querySelector('.wt-collapse__target');

        if (other.classList.contains('is-open')) {
          this.close(other, otherTrigger, otherContent);
        }
      }

      this.open(item, trigger, content);
    }

    open(item, trigger, content) {
      item.classList.add('is-open');
      trigger.classList.add('wt-collapse__trigger--active');
      trigger.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');

      if (content) {
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    }

    close(item, trigger, content) {
      item.classList.remove('is-open');

      if (trigger) {
        trigger.classList.remove('wt-collapse__trigger--active');
        trigger.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (content) {
        content.style.maxHeight = '0';
      }
    }
  }

  window.YellowdayPDPAccordion = {
    initAll(root = document) {
      const accordions = root.querySelectorAll('.pdp-accordion');

      for (const accordion of accordions) {
        if (accordion.dataset.pdpAccordionInitialized === 'true') continue;

        accordion.dataset.pdpAccordionInitialized = 'true';
        new PDPAccordion(accordion);
      }
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.YellowdayPDPAccordion.initAll();
    });
  } else {
    window.YellowdayPDPAccordion.initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    window.YellowdayPDPAccordion.initAll(event.target);
  });
})();
